module.exports = __webpack_public_path__ + "static/img/view4.96d4225.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/view4.png
// module id = +7fu
// module chunks = 0